import { retryRegisterPushInBackground } from '../../../lib/push-register';

export type PushActivationOutcome = 'activated' | 'denied' | 'failed';

export function interpretPushActivation(ok: boolean): PushActivationOutcome {
  const permission = typeof Notification === 'undefined' ? 'denied' : Notification.permission;
  if (permission === 'granted') {
    if (!ok) retryRegisterPushInBackground();
    return 'activated';
  }
  if (permission === 'denied') return 'denied';
  return ok ? 'activated' : 'failed';
}
